export function setCookie(cookieName, cookieValue, exdays = 29) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();

  const cookie = `${cookieName}=${cookieValue};${expires};path=/`
  document.cookie = cookie
}
